import _ from 'lodash';
import * as type from './types';
export default (state = [], action) => {
  switch (action.type) {
    case type.FETCH_CUSTOMERS:
      return { ..._.mapKeys(action.payload, 'id') };
    case type.FETCH_CUSTOMER:
      return { ...state, [action.payload.id]: action.payload };
    case type.CREATE_CUSTOMER:
      return { ...state, [action.payload.id]: action.payload };
    case type.EDIT_CUSTOMER:
      return { ...state, [action.payload.id]: action.payload };
    case type.DELETE_CUSTOMER:
      return _.omit(state, action.payload);
    default:
      return state;
  }
};
